import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { memo, Suspense } from 'react';
import { isLocal } from '../../environment';
import { FieldProps, Schema } from '../types';
import resolveFieldComponent from '../resolveFieldOrWidget/resolveFieldOrWidgetComponent';

type Props = FieldProps<Schema>;

function Field(props: Props) {
  const { getText } = useTranslations();

  if (isLocal && !props.name) {
    throw new Error(`
      Tried to render a <Field /> without a name. You have likely tried
      to render a Field without a definition in the schema.

      Please remove the superfluous <Field />s or check spelling. In the
      future the type system should be able to identify this.
    `);
  }

  if (props.schema.$uiOptions && props.schema.$uiOptions.hidden) {
    return null;
  }

  const Component = resolveFieldComponent(props.schema);

  return (
    <Suspense fallback={<div />}>
      <Component {...props} getText={getText} />
    </Suspense>
  );
}

export default memo(Field);
